import ru from './ru'
import en from './en'
import cn from './cn'

const locale = { ru, en, cn }

export default locale
